package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.section.SideBar
import devxertech.com.section.TopBar
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CommonHeader(image: String,
                 breakpoint: Breakpoint,
                 headingText : String,
                 descriptionText : String,
                 startProject: Boolean = true,
                 careerHeight: Boolean = false,
                 careerHeaderText: Boolean = false,
                 careerFontSize: Boolean = false,
                 showExtraText: Boolean = true,
                 commonPortfolioChanges: Boolean = false,
                 chatbotHeightModification: Boolean = false, chatbotChanges: Boolean = false,
                 heightModification: Boolean = false, careerHeightModification: Boolean = false) {
    val sitePalette = ColorMode.current.toSitePalette()
    var isQuoteHovered by remember { mutableStateOf(false) }
    val ctx = rememberPageContext()
    var isSideMenuOpen by remember { mutableStateOf(false) }
    var isButtonHovered by remember { mutableStateOf(false) }

    if (isSideMenuOpen) {
        SideBar(breakpoint = breakpoint, onClose = { isSideMenuOpen = false }, showExtraText = true)
    }
    Box(modifier = Modifier.fillMaxWidth()
        .position(Position.Relative))
    {
        Column(modifier = Modifier.fillMaxWidth()
            .height(if (careerHeight) 630.px else if (breakpoint > Breakpoint.MD || chatbotHeightModification) 830.px else 730.px)
            .backgroundImage(
                linearGradient(
                    LinearGradient.Direction.ToBottomLeft,
                    sitePalette.headerGradientOne.rgb,
                    sitePalette.headerGradientTwo.rgb)
            )
        ) {
            TopBar(breakpoint, onMenuClick = { isSideMenuOpen = true }, showExtraText, isServiceHeader = true, )
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(leftRight = if (breakpoint <= Breakpoint.MD) 30.px else 122.px,
                        top = when {
                            careerHeight -> if (breakpoint <= Breakpoint.MD) 150.px else 0.px
                            else -> if (breakpoint < Breakpoint.MD) 50.px else 20.px
                        })
                    .flexWrap(if (breakpoint < Breakpoint.MD) FlexWrap.Wrap else FlexWrap.Nowrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (breakpoint >= Breakpoint.MD) Arrangement.SpaceAround else Arrangement.Center
            ) {
                Column (
                    horizontalAlignment = if (breakpoint > Breakpoint.MD) Alignment.Start else Alignment.CenterHorizontally,){
                    FieldTitleTextNormalSimple(
                        text = headingText,
                        width = if(window.screen.width in 400..1269)400.px else if(window.screen.width < 400 ) 300.px
                        else if(window.screen.width in 1270.. 1600) 600.px
                        else 750.px,
                        color = sitePalette.bodyBackgroundSecondary.rgb,
                        fontSize = when {
                            window.screen.width > 1600 -> 50.px
                            window.screen.width in 1270.. 1599 -> 48.px
//                            breakpoint > Breakpoint.LG -> 65.px
                            else -> 30.px
                        },
//                        fontSize = if (breakpoint > Breakpoint.LG) 65.px else if(window.screen.width in 1270.. 1450) 45.px else 32.px,
                        textAlign = if(breakpoint >= Breakpoint.MD) TextAlign.Start else TextAlign.Center,
                        fontWeight = 600,
                        marginTop = when {
                            window.screen.width > 1640 -> if (careerFontSize) 70.px else 90.px
                            window.screen.width in 800..1200 -> if (careerFontSize) (-30).px else 0.px
                            window.screen.width < 800 -> if (careerFontSize) 0.px else 70.px
                            else -> 70.px
                        },
                        paddingTop = if (chatbotChanges && breakpoint <= Breakpoint.MD) 50.px else 0.px,
                        lineHeight = if (breakpoint <= Breakpoint.LG) 40.px else
                            if (window.screen.width > 1600) 55.px else 60.px,
                        whiteSpace = WhiteSpace.PreWrap
                    )
                    FieldTitleTextNormalSimple(
                        text = descriptionText,
//                        width = if(window.screen.width in 400..1269) 400.px else if(window.screen.width < 400 ) 300.px else if(breakpoint < Breakpoint.ZERO) 200.px else 750.px,
                        width = if(window.screen.width in 400..1269)400.px else if(window.screen.width < 400 ) 300.px
                        else if(window.screen.width in 1270.. 1600) 530.px
                        else 750.px,
                        color = sitePalette.bodyBackgroundSecondary.rgb,
                        fontSize = when {
                            window.screen.width > 1600 -> 22.px
                            window.screen.width in 900..1269 -> if (careerFontSize) 17.px else 20.px
                            breakpoint >= Breakpoint.MD -> 20.px
                            else -> 16.px
                        },
                        textAlign =  if(breakpoint >= Breakpoint.MD) TextAlign.Start else TextAlign.Center,
                        fontWeight = 500,
                        marginTop = if (careerHeaderText) 5.px else 10.px,
                        marginBottom = 20.px,
                        whiteSpace = WhiteSpace.PreWrap
                    )
                    if  (breakpoint <= Breakpoint.MD){
                        Image(
                            src = image,
                            modifier = Modifier
                                .width(300.px)
                                .height(249.px).margin(top = if (careerHeight) 0.px else 20.px)
                        )
                    }
                    if (startProject) {

                        Box(
                            modifier = Modifier
                                .width(170.px)
                                .height(42.px)
                                .onClick { ctx.router.navigateTo("/contact-us") }
                                .cursor(Cursor.Pointer)
                                .onMouseEnter { isButtonHovered = true }
                                .onMouseLeave { isButtonHovered = false }
                                .margin(top = if (breakpoint <= Breakpoint.MD) 30.px else 0.px)
                                .position(Position.Relative)
                                .display(DisplayStyle.Flex)
                                .justifyContent(JustifyContent.Center)
                                .backgroundColor(if (isButtonHovered) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
                                .styleModifier {
                                    property("background-color", "#254D79") // base color (blue)
                                    property("color", "white")
                                    property("align-items", "center")
                                }
                        ) {
                            // Overlay Box like ::before
                            Box(
                                modifier = Modifier
                                    .fillMaxSize()
                                    .position(Position.Absolute)
                                    .top(0.px)
                                    .left(0.px)
                                    .backgroundColor(if (isButtonHovered) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.commonSecondaryButtonColor.rgb)
                                    .zIndex(0)
                                    .styleModifier {
                                        property("will-change", "clip-path")
                                        property("transition", "clip-path 0.2s ease-in-out, opacity 0.1s ease-in-out")
                                        property("opacity", if (isButtonHovered) "1" else "0.999")
                                        property(
                                            "clip-path",
                                            if (isButtonHovered)
                                                "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)"
                                            else
                                                "polygon(98% 98%, 99% 98%, 99% 99%, 98% 99%)"
                                        )
                                    }
                            )
                            Box(
                                modifier = Modifier
                                    .size(12.px)
                                    .position(Position.Absolute)
                                    .bottom(0.px)
                                    .right(0.px)
                                    .backgroundColor(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                                    .transform {
                                        translateX(5.5.px)
                                        translateY(5.px)
                                    }
                                    .zIndex(10)
                                    .styleModifier {
                                        property("opacity", if (isButtonHovered) "0" else "1")
                                        property("transition", "opacity 0.0s ease")
                                    }
                            )


                            SpanText( text = "Start A Project",
                                modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(17.px)
                                    .letterSpacing(0.3.px)
                                    .fontWeight(500)
                                    .color(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                                    .zIndex(1))
                        }
                    }

//                        CommonButton(text = "Start A Project", onClick = {ctx.router.navigateTo("/contact-us") })
//                        Box(
//                            modifier = Modifier
//                                .width(182.px)
//                                .height(41.px)
//                                .margin(top = if (breakpoint > Breakpoint.MD)10.px else 30.px)
////                                .backgroundImage(
////                                    linearGradient(
////                                            LinearGradient.Direction.ToRight,
////                                            sitePalette.commonSecondaryButtonColor.rgb,
////                                            sitePalette.topBarButton.rgb
////                                        )
////                                )
//                                .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)
////                                .onMouseEnter { isQuoteHovered = true }
////                                .onMouseLeave { isQuoteHovered = false }
//                                .cursor(Cursor.Pointer)
//                                .align(if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.Start)
//                                .onClick { ctx.router.navigateTo("/contact-us") },
//                            contentAlignment = Alignment.Center
//                            ) {
//                                Row(
//                                    modifier = Modifier.fillMaxWidth(),
//                                    verticalAlignment = Alignment.CenterVertically,
//                                    horizontalArrangement = Arrangement.SpaceEvenly
//                                ) {
//                                    FieldTitleTextNormalSimple(
//                                        " Start A Project",
//                                        isClickable = true,
//                                        color = sitePalette.bodyBackground.rgb,
//                                        fontSize = 17.px
//                                    )
////                                    FaArrowRight(
////                                        modifier = Modifier.color(
////                                            color = sitePalette.bodyBackground.rgb
////                                        )
////                                    )
//                                }
//                            }

                    }

                if  (breakpoint > Breakpoint.MD){
                    Image(
                        src = image,
                        modifier = Modifier
                            .width(
                                when{
                                    window.screen.width > 1670 && commonPortfolioChanges-> 32.percent
                                    window.screen.width > 1610 -> 40.percent
                                    else -> 45.percent
                                }
//                                if (window.screen.width > 1675) 40.percent
//                                else 45.percent
                            )
                            .height(
                                when {
                                    window.screen.width > 1610 && careerHeightModification -> 485.px
                                    window.screen.width > 1600 && heightModification -> 575.px
                                    window.screen.width >= 1440 && heightModification -> 550.px
                                    breakpoint > Breakpoint.XL -> 450.px
                                    else -> 640.px
                                }
                            )
                            .margin(
                                top = when {
                                    window.screen.width > 1610 && careerHeightModification -> 110.px
                                    window.screen.width > 1600 && heightModification -> 85.px
                                    window.screen.width in 800..1200 -> 37.px
                                    else -> 70.px
                                },
                                left = if (window.screen.width in 800..1200) 0.px else (0).px
                            )
                    )
                }
            }
        }
    }
}


